module.exports = __webpack_public_path__ + "img/cigangzhou.prt.df130fed.jpg";